import { API_URL } from '~/config/environment';

export const fetcher = async <T = unknown>(url: string): Promise<T> => {
  const response = await fetch(`${API_URL}${url}`);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
